import { render, staticRenderFns } from "./project-report.vue?vue&type=template&id=702c48cb&scoped=true&lang=pug"
import script from "./project-report.vue?vue&type=script&lang=js"
export * from "./project-report.vue?vue&type=script&lang=js"
import style0 from "./project-report.vue?vue&type=style&index=0&id=702c48cb&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "702c48cb",
  null
  
)

export default component.exports